import { ready } from "//au.roborock.com/cdn/shop/t/5/assets/GA4-track-directive-core.js?vTrack=202605191002&v=89656623417722696801790219985";
import { trackReport } from "//au.roborock.com/cdn/shop/t/5/assets/GA4-track-directive-report.js?vTrack=202605191002&v=104115401213510859531779615950";
import {
  bindTrackClick,
  setupGlobalClickTracking,
} from "//au.roborock.com/cdn/shop/t/5/assets/GA4-track-directive-vTrackClick.js?vTrack=202605191002&v=83823768997871533621790230742";
import { bindTrackHover } from "//au.roborock.com/cdn/shop/t/5/assets/GA4-track-directive-vTrackHover.js?vTrack=202605191002&v=100090243231224703351790230742";
import { bindTrackVisible } from "//au.roborock.com/cdn/shop/t/5/assets/GA4-track-directive-vTrackVisible.js?vTrack=202605191002&v=92712400930102232891790230742";
import { bindTrackVisibleTime } from "//au.roborock.com/cdn/shop/t/5/assets/GA4-track-directive-vTrackVisibleTime.js?vTrack=202605191002&v=146629601693148704391790230742";

/**
 * Shopify GA4埋点指令运行时
 *
 * 目的：在非 Vue 的 Shopify 静态模板里，模拟自建站的 `v-track-*` 指令写法。
 * 页面 HTML 只负责声明：
 * - `v-track-context='{...}'`：给子元素注入公共参数
 * - `v-track-click:event_name='{...}'`：点击上报
 * - `v-track-click:event_name.bubble='{...}'`：冒泡阶段上报
 * - `v-track-click:event_name.delegate='{...}'`：委托点击上报
 * - `v-track-hover:event_name='{...}'`：悬停/聚焦上报
 * - `v-track-hover:event_name.once='{...}'`：悬停/聚焦只上报一次
 * - `v-track-visible:event_name='{...}'`：元素曝光上报
 * - `v-track-visible-time='{...}'`：曝光和停留时长上报
 * - `v-track-visible-time.once='{...}'`：曝光和停留时长只上报一次
 * - `v-track-global-params='{...}'`：挂载到 window.__trackData 的全局埋点参数
 *
 * 注意：模板里的参数必须是合法 JSON 字符串，不使用 eval，避免脚本注入风险。
 */

// 扫描全页面元素并按声明的 `v-track-*` 属性绑定对应埋点行为。
function init() {
  setupGlobalClickTracking();

  const elements = Array.prototype.slice.call(document.getElementsByTagName('*'));

  elements.forEach(function (el) {
    bindTrackClick(el);
    bindTrackHover(el);
    bindTrackVisible(el);
    bindTrackVisibleTime(el);
  });
}

// 保留手动上报入口，方便少数无法用指令覆盖的异步场景复用同一 dataLayer 结构。
window.pushGa4TrackEvent = function (eventName, eventParameters) {
  trackReport({
    event_name: eventName,
    event_parameters: eventParameters || {},
  });
};

// 暴露手动重扫入口，供页面异步插入带指令 DOM 后主动初始化。
window.initGa4TrackDirectives = function () {
  init();
};

ready(init);